
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
  "testString": "בדיקה",
  "visualizationSlideoutTitle": "המחשות חזותיות",
  "listSeparator": ",",
  "pointSeparator": ":",
  "propFillColor": "צבע מילוי",
  "propBorderColor": "צבע גבול",
  "propColorPalette": "בורר צבעים",
  "propDonutRadius": "רדיוס טבעת",
  "showTitleLabel": "הצגת כותרת",
  "titleTypeLabel": "סוג כותרת",
  "smartTitleLabel": "כותרת חכמה",
  "customTitleLabel": "כותרת מותאמת",
  "propHeatScalePalette": "בורר חום",
  "propMaintainAxisScales": "שמירת קנה מידה של ציר",
  "propLineAndSymbolColor": "צבע קווים וסמלים",
  "propElementColor": "צבע מרכיבים",
  "tabName_general": "כללי",
  "tabName_visDetails": "פרטים",
  "tabName_animation": "הנפשה",
  "tabName_textDetails": "פרטי תמליל",
  "tabName_mediaDetails": "פרטי מדיה",
  "tabName_webDetails": "פרטי דף רשת",
  "tabName_imageDetails": "פרטי תמונה",
  "statDetailsPerspectiveTitle": "ניתוח",
  "emptyStatDetailsPanel": "לא זמינים ניתוחים נוספים עבור ההמחשה הנוכחית.",
  "catalyst_service_bad_request": "בקשה שגויה",
  "catalyst_service_unkown_Id": "נמצא זיהוי בקשה לא מוכר",
  "catalyst_service_internal_server_error": "שגיאת שרת פנימית",
  "catalyst_service_generic_error": "שגיאת שירות Catalyst",
  "propLegendPosition": "מיקום מקרא",
  "propLeft": "שמאל",
  "propRight": "ימין",
  "propTop": "עליונים",
  "propBottom": "תחתונים",
  "propNone": "ללא",
  "propLegendDisplay": "הצגת מקרא",
  "visRecommendedTypes": "סוגי המחשות מומלצים",
  "visMore": "עוד...‏",
  "visMoreTooltip": "עוד המחשות",
  "visOtherTypes": "סוגי המחשות אחרים",
  "visChange": "שינוי המחשה",
  "automaticTypeCaption": "אוטומטי",
  "propVisType": "סוגי המחשה חזותית",
  "dlg_loading": "טעינה מתבצעת...‏",
  "areaChartCaption": "שטחים",
  "barChartCaption": "טורים",
  "columnChartCaption": "עמודה",
  "stackedbarChartCaption": "טורים מוערמים",
  "stackedcolumnChartCaption": "עמודות מוערמות",
  "bubbleChartCaption": "בועות",
  "scatterChartCaption": "פיזור",
  "lineChartCaption": "קו",
  "pointChartCaption": "נקודות",
  "heatChartCaption": "מפת חום",
  "pieChartCaption": "עוגה",
  "mapChartCaption": "מפה",
  "radialBarChartCaption": "רדיאלי",
  "compositeChartCaption": "קו ועמודה",
  "wordCloudChartCaption": "ענן מילים",
  "networkChartCaption": "רשת",
  "treemapChartCaption": "מפת עץ",
  "packedBubbleChartCaption": "בועות דחוס",
  "spiralChartCaption": "ספירלה",
  "decisionTreeChartCaption": "עץ החלטה",
  "legacyMapChartCaption": "מפה מגרסאות קודמות",
  "memberCalculationActionText": "חישוב איברים",
  "toolbarActionCalculation": "חישוב",
  "toolbarActionEditCalculation": "עריכת חישוב",
  "topBottomRankLabel": "דירוג (%{label})",
  "toolbarDeleteFilterActionText": "סילוק מסנן",
  "aria_label_datatable": "טבלת נתונים",
  "summaryCaption": "סיכום",
  "MeasuresCaption": "מדדים",
  "MeasuresGroupCaption": "קבוצות מדדים (%{count})",
  "ValuesCaption": "ערכים",
  "turnInsightsOn": "הפעלת תובנות",
  "turnInsightsOff": "השבתת תובנות",
  "decisionRules": "כללים",
  "decisionTree": "עץ",
  "switchToDecisionRules": "מעבר לכללי החלטה",
  "switchToDecisionTree": "מעבר לעץ החלטה",
  "data_group_less_then": "קטן מ-%{rangeTo}",
  "data_group_to": "%{rangeFrom} עד < %{rangeTo}",
  "data_group_and_above": "%{rangeFrom} ומעלה",
  "nullValueContent": "(ללא ערך)",
  "sum": "סכום",
  "count": "ספירה",
  "countdistinct": "ספירה נבדלת",
  "avg": "ממוצע",
  "min": "מינימום",
  "max": "מקסימום",
  "custom": "מותאם",
  "automatic": "מותאם",
  "variance": "שונות",
  "stddev": "סטיית תקן",
  "median": "חציון",
  "calculated": "מחושב",
  "aggregatedColumnLabel": "%{column} (%{aggregationTypeLabel})",
  "preAggregateLabel": "החלת ערכי הנחיות ממקור הנתונים",
  "postAggregateLabel": "החלת ערכי הנחיות בדוח",
  "preAggregateText": "הטווח משתמש בערכים שבמקור הנתונים, לא בערכים המוצגים בלוח המחוונים.",
  "defaultAggregation_count": "ספירה",
  "defaultAggregation_countdistinct": "ספירה נבדלת",
  "defaultAggregation_max": "מקסימום",
  "defaultAggregation_min": "מינימום",
  "defaultAggregation_avg": "ממוצע",
  "defaultAggregation_sum": "סכום",
  "defaultAggregation_auto": "אוטומטי (%{aggregationType})",
  "keydriver_average": "ממוצע כולל",
  "keydriver_up_down": "קבוצות מובלטות עם ממוצעים גבוהים או נמוכים משפיעות יותר על היעד. לקבוצות עם ממוצעים גבוהים או נמוכים במיוחד יש ההשפעה הרבה ביותר.",
  "keydriver_different": "לקבוצות מובלטות יש התפלגויות הנבדלות באופן משמעותי מההתפלגות הכוללת. קבוצות אלה משפיעות יותר על היעד.",
  "topOperator": "עליונים",
  "bottomOperator": "תחתונים",
  "topBottomFact": "%{value}%{percent} %{operator} לפי %{columnLabel}",
  "topBottomDimension": "%{value}%{percent} %{operator}",
  "deleteTopBottomCount": "מחיקת ספירת עליונים או תחתונים",
  "deleteTopBottomPercent": "מחיקת אחוזים עליונים או תחתונים",
  "topBottomTitle": "אובייקט זה בלבד",
  "deleteTopBottom": "מחיקת ספירת עליונים או תחתונים",
  "editTopBottom": "עריכת ספירת עליונים או תחתונים",
  "editTopBottomCount": "עריכת ספירת עליונים או תחתונים",
  "editTopBottomPercent": "עריכת אחוזים עליונים או תחתונים",
  "ariaDeleteTopBottomCountLabel": "לחצו על מקש DELETE כדי למחוק את ספירת העליונים או התחתונים.",
  "ariaDeleteTopBottomPercentLabel": "לחצו על מקש DELETE כדי למחוק את האחוזים העליונים או התחתונים.",
  "ariaEditTopBottomCountLabel": "לחצו על Enter כדי לערוך את ספירת העליונים או התחתונים.",
  "ariaEditTopBottomPercentLabel": "לחצו על Enter כדי לערוך את האחוזים העליונים או התחתונים.",
  "ariaDeleteDrillStateLabel": "לחצו על Enter כדי לערוך את ספירת העליונים או התחתונים.",
  "drillUpStateTitle": "עליית רמה",
  "drillDownStateTitle": "ירידת רמה",
  "ariaEditTopBottomLabel": "לחצו על Enter כדי לערוך את ספירת העליונים או התחתונים.",
  "ariaDeleteTopBottomLabel": "לחצו על מקש DELETE כדי למחוק את ספירת העליונים או התחתונים.",
  "filter_drag_and_drop_single_dock": "גררו ושחררו נתונים כאן כדי לסנן.",
  "filter_drag_and_drop_all_tabs": "גררו ושחררו נתונים כאן כדי לסנן את כל הלשוניות.",
  "filter_drag_and_drop_current_tab": "גררו ושחררו נתונים כאן כדי לסנן לשונית זו.",
  "filterClearAllItems": "ניקוי כל המסננים",
  "filterDeleteAllItems": "מחיקת כל המסננים",
  "filterDockChevronLeft": "גלילה בנתונים",
  "filterDockChevronRight": "גלילה בנתונים",
  "filterIconLabel_Single": "מסננים",
  "filterIconLabel_Global": "כל הלשוניות",
  "filterIconLabel_Tab": "לשונית זו",
  "filterIconTooltip_Single": "מסננים",
  "filterIconTooltip_Global": "כל הלשוניות",
  "filterIconTooltip_Tab": "לשונית זו",
  "filterOverflowMenu_Global": "תפריט גלישה של כל הלשוניות",
  "filterOverflowMenu_Tab": "תפריט גלישה של לשונית זו",
  "expand": "הרחבה",
  "collapse": "כיווץ",
  "filterOverflowMenu_Item": "סינון תפריט גלישה",
  "filterItemCanvasMove": "הוספת יריעה",
  "filterItemDelete": "מחיקת מסנן",
  "filterInvertRange": "הכל מלבד: %{from}-%{to}",
  "filterRange": "%{from}-%{to}",
  "filter_date_after_except": "לא אחרי %{from}",
  "filter_date_after": "לאחר %{from}",
  "filter_date_before_except": "לא לפני %{to}",
  "filter_date_before": "לפני %{to}",
  "filter_date_between_except": "לא בין %{from}-%{to}",
  "filter_date_between": "בין %{from}-%{to}",
  "filterValueSeparator": ",",
  "filterAll": "הכל",
  "filterExcept": "מלבד %{values}",
  "navigateTitle": "ניווט אל",
  "current_nav_group": "קבוצת הניווט הנוכחית היא %{navigation_group_name}",
  "next": "הבא",
  "previous": "הקודם",
  "multiselectMsg": "%{count} פריטים נבחרו",
  "errMsgFilterItemGenericTitle": "לא ניתן לטעון את ערכי המסנן",
  "textFilterItemsNotFound": "אין פריטים זמינים.",
  "nullValueLabel": "(ריק)",
  "filterConditionLabel": "תנאי מסנן",
  "filter_includesAll": "כולל הכל",
  "modelFilter": "מסנן",
  "search": "חיפוש",
  "clearTextFilterValue": "ניקוי",
  "invertFilterSelection": "היפוך",
  "modellingLoading": "טעינה מתבצעת...‏",
  "toolbarActionSort": "מיון",
  "toolbarActionSortAscending": "מיון עולה",
  "toolbarActionSortDescending": "מיון יורד",
  "toolbarActionSortAuto": "אוטומטי (%{sortOrder})",
  "toolbarActionFormat": "מבנה",
  "toolbarActionFormatAbbreviation": "קיצור",
  "toolbarActionFormatNone": "אוטומטי",
  "toolbarActionFilter": "מסנן",
  "toolbarActionTopBottom": "ראש או תחתית",
  "toolbarActionAddShape": "הוספת צורה",
  "toolbarActionRmvShape": "סילוק צורה",
  "toolbarActionToggleShapeDrop": "צורה אינפוגרפית",
  "toolbarActionToggleShapeDropTitle": "יצירת אינפוגרפיקה",
  "toolbarActionToggleShapeDropText": "גררו צורה לשדה זה כדי ליצור אינפוגרפיקה.",
  "toolbarActionAggregationType": "סיכום",
  "toolbarDeleteActionText": "סילוק עמודה",
  "toolbarActionFilterLocalKeepSelected": "השארה",
  "toolbarActionFilterLocalExcludeSelected": "סינון",
  "toolbarActionFilterAllKeepSelected": "מסנן",
  "toolbarActionSimpleCalculation": "חישוב פשוט",
  "toolbarActionDrillBack": "אחורה",
  "toolbarActionDrillUp": "עליית רמה",
  "toolbarActionDrillDown": "ירידת רמה",
  "toolbarActionNavigate": "ניווט",
  "toolbarActionCreateFilterGroup": "יצירת חיבור חדש",
  "toolbarActionDisconnectFilterGroup": "שבירת כל הקישורים",
  "toolbarActionLinkFilterGroup": "הוספה לחיבור קיים",
  "dlg_ascending": "עולה",
  "dlg_descending": "יורד",
  "dlg_custom": "מותאם",
  "dlg_none": "ללא",
  "editTimelineHighlight": "עריכת הבלטה",
  "timelineHighlightTitle": "הבלטה",
  "visualizationLabel": "המחשה",
  "chartLabel": "תרשים %{chartName}",
  "dataWidgetDescription": "%{widgetLabel}: %{columnNames}",
  "f12KeyDescription": "לחצו על F12 כדי לנווט בתוך הפקד.",
  "f10KeyDescription": "לחצו על F10 כדי להפעיל את תצוגת המוקד של הפקד",
  "playButtonLabel": "הרצה",
  "dataPlayerValueListLabel": "ערכי נגן נתונים",
  "localFilterTitle": "אובייקט זה בלבד",
  "globalFilterTitle": "כל האובייקטים",
  "deleteFilter": "מחיקת מסנן",
  "editFilter": "עריכת מסנן",
  "ariaEditFilterLabel": "לחצו על מקש ENTER כדי לערוך את המסנן.",
  "ariaDeleteFilterLabel": "לחצו על מקש DELETE כדי למחוק את המסנן.",
  "measureFilterBetween": "בטווח %{lowerBound} עד %{upperBound}",
  "measureFilterNotBetween": "לא  בין %{lowerBound} לבין %{upperBound}",
  "dimFilterIn": "כולל: %{in}",
  "dimFilterNotIn": "לא כולל: %{out}",
  "gtFilter": "לאחר %{lowerBound}",
  "ltFilter": "לפני %{upperBound}",
  "ariaEditPrompt": "לחצו על מקש ENTER כדי לשנות את ערך ההנחיה.",
  "dataPointFilterTitle": "נקודות נתונים",
  "dataPointFilterIncludeSummary": "נכללו %{valueCount} נקודות נתונים",
  "dataPointFilterExcludeSummary": "לא נכללו %{valueCount} נקודות נתונים",
  "widgetFiltersLabel": "פקד מסננים",
  "srILVTreeLabel": "רשימה",
  "geomapUnrecognizedLocations": "מיקומים לא מזוהים:",
  "geomapAmbiguousLocations": "אזורים רב-משמעיים:",
  "LIVE_empty_visualization_hint_title": "בנו את ההמחשה שלכם",
  "LIVE_empty_visualization_hint_description": "גררו ושחררו עמודות כאן או אל המשבצות משמאל.",
  "LIVE_slots_required_field_description": "%{asterisk} מציין שדה דרוש",
  "LIVE_slots_drag_and_drop_description": "גררו ושחררו נתונים במשבצות למעלה כדי לבנות ולסנן את ההמחשה",
  "dwErrorLoadingAvailableVisualizations": "לא ניתן לטעון את הגדרות ההמחשות הזמינות",
  "propScaleLabel": "כמות איקונים",
  "propScaleDescription": "בחרו כמות האיקונים",
  "propScaleFew": "נמוך",
  "propScaleDefault": "ברירת מחדל",
  "propScaleMany": "גבוה",
  "lastRefresh": "רענון אחרון: לפני %{timeInterval}",
  "widgetTimer": "קוצב זמן של פקד",
  "datasetItemsUnavailable": "חלק מפריטי ערכת הנתונים המשמשים בהמחשה זו אינם זמינים.",
  "datasetItemUnavailable": "פריט ערכת נתונים זה אינו זמין.",
  "retry": "נסיון חוזר",
  "widgetConditionalFormatLabel": "מיתוג בקרות עיצוב מותנה",
  "crosstabName": "הצלבת נתונים בטבלה",
  "WidgetLabelWithDescripion": "%{label}. %{description}",
  "value_is_not_available": "לא ישים",
  "summaryLabel": "%{label} עם הערך %{value}",
  "warning": "אזהרה",
  "swapRowsAndColumns": "החלפת שורות ועמודות",
  "hideShowSummaries": "הסתרת סיכומי מצגת",
  "dataAssetPropertiesLabel": "תכונות המחשה",
  "evAdd": "הוספת עמודה",
  "evCollapse": "כיווץ",
  "evColumns": "עמודות",
  "evLocalFilters": "מסננים מקומיים",
  "evExpand": "הרחבה",
  "evFilterTooltip": "מסנן",
  "missingColumn": "חסר: %{columnLabel}",
  "missingFiltering": "חסרים מסננים בזיהויי העמודות שלהלן:",
  "heatByLabel": "חום לפי",
  "toolbarChangeVisualization": "שינוי המחשה",
  "unSupportedPromptType": "תרחיש ההנחיות אינו נתמך כרגע.",
  "modellingRelatedTablesNoneFound": "לא נמצאו טבלאות קשורות"
});
